<template>
    <div class="notification-panel elevation-16" :class="{ 'notification-panel--expanded': isExpanded }">





        <div class="notification-panel__header d-flex justify-space-between">

            <div class="notification-panel__title text-h6 font-weight-bold">Notifications</div>
            <v-icon @click="closeNotificationPanel" class="notification-panel__close-icon">
                <close style="width: 12px; height: 12px" />
            </v-icon>

        </div>






        <div class="notification-panel__list-container">

            <component v-for="(notification, index) in notifications" :key="notification.id || index"
                :is="getComponent(notification)" :notification="notification"
                :style="{ 'margin-top': index === 0 ? '22px' : '24px' }">
            </component>

            <EmptyNotification v-if="notifications.length === 0"
                class="notification-panel__empty-notification"></EmptyNotification>

        </div>




        <v-divider class="my-5" />




        <div class="notification-panel__footer d-flex justify-center">

            <v-btn @click.stop="toggleExpand()" rounded="pill" class="button--primary notification-panel__expand-button"
                style="font-size: 13px; text-transform: none;">
                {{ isExpanded ? 'Collapse' : 'Expand' }}
            </v-btn>

        </div>





    </div>
</template>



<script>

import log from "@/api/services/LogService";
import { computed, ref } from "vue";
import Close from '@/icons/Close.vue';
import MarkRead from '@/icons/MarkRead.vue';
import EmptyNotification from "./Empty-Notification.vue";
import { NotificationType } from "@/constants/NotificationType";
import { NotificationsStore } from "@/store/NotificationsStore";

import OfferNotificationTile from "@/components/Tiles/Notification/OfferNotificationTile.vue";
import PayoutStatusNotificationTile from "@/components/Tiles/Notification/PayoutNotificationTile.vue";
import OfferWallNotificationTile from "@/components/Tiles/Notification/OfferWallNotificationTile.vue";
import InhouseTaskNotificationTile from "@/components/Tiles/Notification/InHouseTaskNotificationTile.vue";
import SpinTheWheelNotificationTile from "@/components/Tiles/Notification/SpinTheWheelNotificationTile.vue";

export default {
    name: "NotificationsList",
    components: {
        Close,
        MarkRead,
        EmptyNotification,
    },
    setup(props, { emit }) {

        const notificationsStore = NotificationsStore();
        const isExpanded = ref(false);

        const priorityOrder = {
            'high': 1,
            'medium': 2,
            'low': 3
        };

        const notifications = computed(() => {
            const allNotifications = notificationsStore.notifications;
            
            // Separate unread and read notifications
            const unreadNotifications = allNotifications.filter(notification => !notification.readAt);
            const readNotifications = allNotifications.filter(notification => notification.readAt);
            
            // Sort unread notifications by priority
            const sortedUnreadNotifications = unreadNotifications.sort((a, b) => {
                // First sort by priority
                const priorityDiff = priorityOrder[a.body?.priority || 'low'] - priorityOrder[b.body?.priority || 'low'];
                if (priorityDiff !== 0) return priorityDiff;
                
                // If same priority, sort by creation time (newest first)
                return b.createdAt - a.createdAt;
            });
            
            // Combine sorted unread notifications with read notifications
            return [...sortedUnreadNotifications, ...readNotifications];
        });

        const getComponent = (notification) => {
            switch (notification.notificationType) {
                case NotificationType.OffersCallback:
                    return OfferNotificationTile;
                case NotificationType.InhouseTask:
                    return InhouseTaskNotificationTile;
                case NotificationType.PayoutStatus:
                    return PayoutStatusNotificationTile;
                case NotificationType.OfferWall:
                    return OfferWallNotificationTile;
                case NotificationType.SpinTheWheel:
                    return SpinTheWheelNotificationTile;
                default:
                    console.warn(`Unknown notification type: ${notification.notificationType}`);
                    return null;
            }
        }

        const toggleExpand = () => {
            isExpanded.value = !isExpanded.value;
        }

        const closeNotificationPanel = () => {
            emit('close');
        }

        return {
            getComponent,
            notifications,
            closeNotificationPanel,
            toggleExpand,
            isExpanded
        }
    },
}
</script>